import { ReactNode } from "react";
import Container from "../Container";
import Separator from "../Separator";
import Tooltip from "../Tooltip";
import "./InputFieldGroupContainer.css";

interface IInputFieldGroupContainerProps {
  label?: string;
  children: ReactNode;
  className?: string;
  hasSeparator?: boolean;
  hasTooltip?: boolean;
  content?: string;
  underDevelopment?: boolean;
  style?: React.CSSProperties;
}

export default function InputFieldGroupContainer({
  label,
  children,
  className,
  hasSeparator = false,
  hasTooltip = false,
  content = "",
  underDevelopment,
  style,
}: IInputFieldGroupContainerProps) {
  return (
    <>
      <div className="inputFieldGroupContainer">
        {label && (
          <div className="label_with_tooltip">
            <label htmlFor={label} className="label input_group_label">
              {label}
              {underDevelopment && (
                <Tooltip content={<p>Section Under Construction</p>}>
                  <i
                    className="icon-construction"
                    style={{ marginLeft: "5px" }}
                  ></i>
                </Tooltip>
              )}
            </label>
            {hasTooltip && (
              <Tooltip content={<p>{content}</p>}>
                <i className="icon-info-circle tooltip"></i>
              </Tooltip>
            )}
          </div>
        )}
        <Container className={className} style={style}>
          {children}
        </Container>
      </div>
      {hasSeparator && <Separator />}
    </>
  );
}
